export enum Periodicity {
  ANNUAL = "Annuelle",
  SEMI_ANNUAL = "Semestrielle",
  QUARTERLY = "Trimestrielle"
}


